import { render, staticRenderFns } from "./DrawingPictureface.vue?vue&type=template&id=b10bc546&scoped=true"
import script from "./DrawingPictureface.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingPictureface.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DrawingPictureface.vue?vue&type=style&index=0&id=b10bc546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10bc546",
  null
  
)

export default component.exports